import { AttributeUiType } from './attributeUiType';
import { AttributeEntityType } from './attributeEntityType';
import { AttributeDefinitionValueListItem } from './attributeDefinitionValueListItem';
import { AttributeDefinitionSubFieldItem } from './attributeDefinitionSubFieldItem';
import { FormulaReturnType } from './formulaReturnType';

export class AttributeDefinitionWrite {
  public entityType: AttributeEntityType;
  public uiType: AttributeUiType;
  public name: string;
  public description: string;
  public adminDocumentation: string;
  public required: boolean;
  public valueList: AttributeDefinitionValueListItem[];
  public subFieldList: AttributeDefinitionSubFieldItem[];
  public min: string;
  public max: string;
  public featured: boolean;
  public filterable: boolean;
  public hasVisualization: boolean;
  public showOnCreate: boolean;
  public isSubField: boolean;
  public hasOther: boolean;
  public includeInRatingCalculation: boolean;
  public formulaExpression?: string;
  public formulaReturnType?: FormulaReturnType;

  constructor() {
    this.valueList = [];
    this.subFieldList = [];
  }
}
